import $ from 'jquery';
import 'slick-carousel';
import { getBreakpoint } from 'Utils/breakpoints';

$(window).on('load', function() {
    $('.video-list__slideshow').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        mobileFirst: true,
        rows: 0,
        slide: '.video-list__slide',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: getBreakpoint('lg'),
                settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3
                }
            }
        ]
    });
});
